(function ($) {
  const dt = new DataTransfer();

  $('.input-file input[type=file]').on('change', function() {
    const filesList = $(this).closest('.input-file').find('.input-file__list');

    for (let i = 0; i < this.files.length; i++) {
      const file = this.files.item(i);
      dt.items.add(file);

      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onloadend = function(){
        const new_file_input = '<div class="input-file__list-item">' +
          '<img class="input-file__list-img" src="' + reader.result + '">' +
          '<span class="input-file__list-name">' + file.name + '</span>' +
          '<a href="#" class="input-file__list-remove">x</a>' +
          '</div>';
        filesList.append(new_file_input);
      }
    }

    filesList.show();
    const btnText = $(this).closest('.input-file').find('.input-file__btn span');
    btnText.html(btnText.attr('data-text-more'));

    setTimeout(function () {
      $('.input-file__list-remove').on('click', function(e) {
        e.preventDefault();
        removeFilesItem($(this));
      });
    }, 100);

    this.files = dt.files;
  });

  function removeFilesItem(target){
    const name = $(target).prev().text();
    const input = $(target).closest('.input-file').find('input[type=file]');
    const filesList = $(target).closest('.input-file').find('.input-file__list');
    const btnText = $(target).closest('.input-file').find('.input-file__btn span');
    console.log(btnText);

    $(target).closest('.input-file__list-item').remove();
    for(let i = 0; i < dt.items.length; i++){
      if(name === dt.items[i].getAsFile().name){
        dt.items.remove(i);
      }
    }
    if (input[0]) {
      input[0].files = dt.files;

      if (input[0].files.length === 0) {
        filesList.hide();
        btnText.html(btnText.attr('data-text-default'));
      }
    }
  }
})(jQuery);
